<template>
  <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 155.022 116.286">
    <g id="商品采集" transform="translate(0 0)">
      <g id="group300" data-name="组 300">
        <path id="路径_181" data-name="路径 181"
              d="M142.048,22.747H118.341a3.637,3.637,0,0,1-3.641-3.641v-.465A3.637,3.637,0,0,1,118.341,15h23.707a3.637,3.637,0,0,1,3.641,3.641v.465A3.637,3.637,0,0,1,142.048,22.747Z"
              transform="translate(-114.7 -3.379)" class="cls-1"></path>
        <path id="路径_182" data-name="路径 182"
              d="M137.447,3.641V27.348a3.637,3.637,0,0,1-3.641,3.641h-.465a3.637,3.637,0,0,1-3.641-3.641V3.641A3.637,3.637,0,0,1,133.341,0h.465A3.637,3.637,0,0,1,137.447,3.641Z"
              transform="translate(-118.079)" class="cls-1"></path>
      </g>
      <path id="路径_183" data-name="路径 183"
            d="M153.086,79.865a4.733,4.733,0,0,0-.542-1.085L133.872,53.912h0a3.874,3.874,0,0,0-6.973,2.324,4,4,0,0,0,.852,2.479h0l11.079,14.72H16.114L26.96,58.947H78.48a3.874,3.874,0,0,0,0-7.747H25.024a3.714,3.714,0,0,0-3.1,1.549L1.007,80.64a3.689,3.689,0,0,0-.7,2.944A12.68,12.68,0,0,0,0,86.527V114.8A13.044,13.044,0,0,0,13.015,127.82H142.007A13.044,13.044,0,0,0,155.022,114.8V86.527A13.669,13.669,0,0,0,153.086,79.865Zm-6.508,34.863a4.713,4.713,0,0,1-4.648,4.648H13.015a4.713,4.713,0,0,1-4.648-4.648v-28.2a4.713,4.713,0,0,1,4.648-4.648H142.007a4.713,4.713,0,0,1,4.648,4.648v28.2Z"
            transform="translate(0 -11.534)" class="cls-1"></path>
      <path id="路径_184" data-name="路径 184"
            d="M103.3,118.547H33.574a3.936,3.936,0,0,1-3.874-3.874h0a3.885,3.885,0,0,1,3.874-3.874H103.3a3.885,3.885,0,0,1,3.874,3.874h0A3.936,3.936,0,0,1,103.3,118.547Z"
            transform="translate(-6.691 -24.961)" class="cls-1"></path>
      <circle id="椭圆_25" data-name="椭圆 25" cx="3.874" cy="3.874" r="3.874"
              transform="translate(116.131 85.839)" class="cls-1"></circle>
    </g>
  </svg>
</template>

<script>
  import * as d3 from 'd3'

  export default {
    data () {
      return {}
    },
    mounted () {

    }
  }
</script>

<style scoped>
  #group300{
    transform: translate(88.861px, 0);
    animation: groupRun 1.5s ease-in-out infinite;
  }
  @keyframes groupRun {
    from{
      transform: translate(88.861px, 0);
    }
    50%{
      transform: translate(88.861px, 20px);
    }
    to{
      transform: translate(88.861px, 0);
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/svgs/ProductCollect.vue